<template class="EGFR">
  <v-row class="DSS__warnings">
    <v-col cols="12" align="right" v-if="amount < 50">
      <v-icon :color="$color.coro['warning-500']">mdi-alert</v-icon>
      {{ $ucfirst($t("dss.lowRenalFunction", { params: { amount: amount } })) }}
    </v-col>
    <v-col cols="12" align="right">
      <v-icon :color="$color.coro['warning-500']">mdi-alert</v-icon>
      {{ $ucfirst($t("dss.ageDiscrepancyWarning")) }}
    </v-col>
    <v-col cols="12" align="right" v-if="age >= 64 && age <= 65">
      <v-icon :color="$color.coro['warning-500']">mdi-alert</v-icon>
      {{ $ucfirst($t("dss.ageBloodPressureCalculationWarning")) }}
    </v-col>
    <v-col cols="12" align="right" v-for="warning in DSSwarnings" :key="warning.id">
      <v-icon :color="$color.coro['warning-500']">mdi-alert</v-icon>
      {{ warning.text }}
    </v-col>
  </v-row>
</template>

<script>
import gql from "graphql-tag";
import { mapGetters } from "vuex";

/**
 * Component EGFR.vue
 *
 * @module EGFR
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/DSS/EGFR.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "egfr",
  data: function () {
    return {
      amount: Number.MAX_SAFE_INTEGER, // Make it a large number -> Avoid appear and disappear after query is done.
    };
  },
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
      age: "patientSummary/age",
      algorithm: 'dss/algorithm',
    }),
    DSSwarnings : function(){
      return this.algorithm?.warnings?.length ? this.algorithm.warnings : []
    }
  },
  watch: {
    patientId: function () {
      this.loadData();
    },
  },
  mounted: function () {
    this.getRenalFunction();
  },
  methods: {
    getRenalFunction() {
      this.$app.apolloMobileClient
        .query({
          query: gql`
            query renalFunction($patientId: String!) {
              myHealthParameters(
                functions: [{ function: patientId, parameters: [$patientId] }]
                conditions: { field: code, value: "69405-9" }
                orders: { field: effectiveDateTime, direction: desc }
                limit: 1
              ) {
                edges {
                  node {
                    valueQuantity {
                      value
                    }
                  }
                }
              }
            }
          `,
          variables: {
            patientId: this.patientId.toString(),
          },
        })
        .then((result) => {
          let amount = result.data.myHealthParameters.edges[0]?.node?.valueQuantity?.value;

          // Only update if there is a result with an amount.
          if(amount) {
            this.amount = parseFloat(amount);
          }
        });
    },
  },
};
</script>

<style>
.DSS__warnings>div{
  padding-bottom: 0;
}
</style>